import { getPortalPathForView } from './portalRoutes';

export const ADMIN_MENU_GROUP_DEFINITIONS = Object.freeze({
    dashboard: {
        label: 'Dashboard',
        icon: 'dashboard',
        items: [{ id: 'dashboard', label: 'Dashboard', icon: 'dashboard', forAll: true }]
    },
    offersEmail: {
        label: 'Offers & Email',
        icon: 'offers',
        items: [
            { id: 'bundle-builder-beta', label: 'Bundle Builder Beta', icon: 'offers', forAll: true },
            { id: 'send-offer', label: 'Send Offer Templates', icon: 'email', forAll: true },
            { id: 'templates', label: 'Templates', icon: 'template', adminOnly: true },
            { id: 'email-settings', label: 'Email Settings', icon: 'settings', adminOnly: true },
            { id: 'all-history', label: 'All History', icon: 'history', adminOnly: true }
        ]
    },
    productPricing: {
        label: 'Product & Pricing',
        icon: 'settings',
        items: [
            { id: 'pricing-manager', label: 'Product Pricing Manager', icon: 'settings', adminOnly: true },
            { id: 'tv-packages-v2', label: 'TV Package Calculator', icon: 'tv', forAll: true },
            { id: 'tv-pricing-v2', label: 'TV Package Pricing & Channels', icon: 'settings', adminOnly: true },
            { id: 'theme-pack-editor', label: 'Theme Pack Editor', icon: 'settings', adminOnly: true },
            { id: 'promo-combo-price', label: 'TELUS Promo Combo', icon: 'template', forAll: true },
            { id: 'rogers-pricing', label: 'Rogers Pricing', icon: 'template', forAll: true }
        ]
    },
    training: {
        label: 'Training',
        icon: 'lessons',
        items: [
            { id: 'new-training-management', label: 'Training Management', icon: 'lessons', adminOnly: true },
            { id: 'training-management', label: 'Sales Manual / Legacy Training', icon: 'lessons', adminOnly: true },
            { id: 'training-test-management', label: 'Training Test Management', icon: 'quiz', adminOnly: true }
        ]
    },
    performance: {
        label: 'Performance',
        icon: 'performance',
        adminOnly: true,
        items: [
            { id: 'system-reports', label: 'Email Performance Reports', icon: 'reports', adminOnly: true },
            { id: 'calls-performance-webhook', label: 'Calls Analytics', icon: 'phone', adminOnly: true },
            { id: 'sds', label: 'SAD / Review Queue', icon: 'sad', adminOnly: true },
            { id: 'my-history', label: 'My History', icon: 'history', forAll: true }
        ]
    },
    admin: {
        label: 'Admin',
        icon: 'people',
        adminOnly: true,
        items: [
            { id: 'users', label: 'Users', icon: 'people', adminOnly: true },
            { id: 'agent-dashboard-manager', label: 'Agent Dashboard Manager', icon: 'dashboard', adminOnly: true },
            { id: 'escalations', label: 'Escalations', icon: 'escalations', adminOnly: true }
        ]
    },
    legacyAdvanced: {
        label: 'Legacy / Advanced',
        icon: 'ai',
        adminOnly: true,
        items: [{ id: 'ai-assistant', label: 'AI Assistant', icon: 'ai', forAll: true }]
    }
});

export const AGENT_MENU_GROUP_DEFINITIONS = Object.freeze({
    dashboard: {
        label: 'Dashboard',
        icon: 'dashboard',
        items: [{ id: 'dashboard', label: 'Dashboard', icon: 'dashboard', forAll: true }]
    },
    quoteTools: {
        label: 'Quote Tools',
        icon: 'offers',
        items: [
            { id: 'bundle-builder-beta', label: 'Bundle Builder Beta', icon: 'offers', forAll: true },
            { id: 'tv-packages-v2', label: 'TV Package Calculator', icon: 'tv', forAll: true },
            { id: 'send-offer', label: 'Send Offer Templates', icon: 'email', forAll: true }
        ]
    },
    resources: {
        label: 'Resources',
        icon: 'template',
        items: [
            { id: 'new-training', label: 'Training', icon: 'lessons', agentOnly: true },
            { id: 'training', label: 'Sales Manual / Legacy Training', icon: 'lessons', agentOnly: true },
            { id: 'promo-combo-price', label: 'TELUS Promo Combo', icon: 'template', forAll: true },
            { id: 'rogers-pricing', label: 'Rogers Pricing', icon: 'template', forAll: true },
            { id: 'ai-assistant', label: 'AI Assistant', icon: 'ai', forAll: true },
            { id: 'escalations', label: 'Escalations', icon: 'escalations', agentOnly: true },
            { id: 'training-test', label: 'Training Test', icon: 'quiz', agentOnly: true }
        ]
    },
    history: {
        label: 'History',
        icon: 'history',
        items: [{ id: 'my-history', label: 'My History', icon: 'history', forAll: true }]
    }
});

export const PROCESSING_MENU_DEFINITIONS = Object.freeze([
    { id: 'bundle-builder-beta', label: 'Bundle Builder Beta', icon: 'offers' },
    { id: 'promo-combo-price', label: 'TELUS Promo Combo', icon: 'template' },
    { id: 'rogers-pricing', label: 'Rogers Pricing', icon: 'template' }
]);

function materializeItem(item, iconMap) {
    return {
        ...item,
        icon: iconMap[item.icon] || null
    };
}

export function materializeMenuGroups(definitions, iconMap) {
    return Object.fromEntries(Object.entries(definitions).map(([groupId, group]) => [
        groupId,
        {
            ...group,
            icon: iconMap[group.icon] || null,
            items: group.items.map((item) => materializeItem(item, iconMap))
        }
    ]));
}

export function materializeProcessingMenu(iconMap) {
    return PROCESSING_MENU_DEFINITIONS.map((item) => ({
        ...materializeItem(item, iconMap),
        url: getPortalPathForView(item.id)
    }));
}
